<!--
/*******************************************************************************
*@ 컴포넌트명   : MainContentsAfLogin.vue
*@ 컴포넌트설명 : 메인 본문 (로그인후) - 자주보는계좌 또는 내계좌 표시
*@ 사용전문     : RBF0404L40 - 내계좌조회 ,
                 RBF0404A40 - 예금계좌거래내역, RBF0401P40 - PUSH발송내역조회
                 /commonbiz/combiz/getAddtlInfo 부가정보 Json파일 조회
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 23.01.16    이가영   비밀번호 사용 180일 초과시 새로운 비밀번호 설정 권유 팝업 추가
********************************************************************************/
-->
<template>
  <article class="contents account">
    <!-- 계좌 선택시 -->
    <div class="summary" v-if="showAcnDtl">
      <!-- 계좌정보 -->
      <div class="account-info -type4">
        <div class="tit">{{ acnInfo.acnoAls ? acnInfo.acnoAls : acnInfo.prdctName }}</div>
        <div class="desc">
          {{
            acnInfo.acnoKnd == "1" ? `${acnInfo.acno} - ${acnInfo.prdctName}` : `${acnInfo.acno} - ${/*대출금리*/ $t("MMAIN-03-03-02-16")} ${acnInfo.lnIrt ? acnInfo.lnIrt : "0"}%`
          }}
        </div>
        <div class="amount">
          <span class="exchange-unit">{{ acnInfo.cncycd }}</span>
          <span class="total" v-html="acnInfo.acnoKnd == '1' ? $num(acnInfo.bal, null, true) : $num(acnInfo.lnBal, null, true)"></span>
        </div>
        <div class="bottom" v-if="acnInfo.acnoKnd2 == '3' && acnInfo.dpstAcnGrid">
          <div class="item" v-for="data in acnInfo.dpstAcnGrid" :key="data.tranYms">
            <div class="tit">{{ $getGlobalDateFmt(data.tranYmd) }}</div>
            <div class="dec amount">
              <em :class="data.brncoInotDstcd == '10' ? 'plus' : 'minus'">{{ data.brncoInotDstcd == "10" ? "+" : "-" }}</em>
              <span class="exchange-unit">{{ data.cncycd }}</span>
              <span class="total" v-html="$num(data.brncoInotDstcd == '10' ? data.mnrcvAmt : data.drwotAmt)"></span>
            </div>
          </div>
        </div>
        <div class="bottom" v-else-if="acnInfo.acnoKnd2 == '4'">
          <div class="item">
            <div class="tit">{{ /*예금이율*/ $t("MMAIN-03-03-02-02") }}</div>
            <div class="dec">{{ `${acnInfo.dpostIrt}%` }}</div>
          </div>
          <div class="item">
            <div class="tit">{{ /*만기일*/ $t("MMAIN-03-03-02-03") }}</div>
            <div class="dec">{{ $getGlobalDateFmt(acnInfo.expirYmd) }}</div>
          </div>
          <div class="item">
            <div class="tit">{{ /*계좌 상태*/ $t("MMAIN-03-03-03-04") }}</div>
            <div class="dec">{{ $t(`${acnInfo.acnStus}_계좌상태구분코드`) }}</div>
          </div>
        </div>
        <div class="bottom" v-else-if="acnInfo.acnoKnd2 == '2'">
          <div class="item">
            <div class="tit">{{ /*이자납부일*/ $t("MMAIN-03-03-03-02") }}</div>
            <div class="dec">{{ $getGlobalDateFmt(acnInfo.nxtrmPaymtYmd) }}</div>
          </div>
          <!-- 당좌대출 차기이자납부금액 미표시 -->
          <div class="item" v-if="acnInfo.ovsesLnFmatDstcd != '08'">
            <div class="tit">{{ /*이자납부금액*/ $t("MMAIN-03-03-03-03") }}</div>
            <div class="dec" v-html="$num(acnInfo.nxtrmIntPaymtAmt, null, true)"></div>
          </div>
          <div class="item">
            <div class="tit">{{ /*계좌 상태*/ $t("MMAIN-03-03-03-04") }}</div>
            <div class="dec">{{ $t(`${acnInfo.acnStus}_계좌상태구분코드`) }}</div>
          </div>
        </div>
      </div>
      <div class="btn-area--full" v-if="acnInfo.acnoKnd2 == '3'">
        <button class="btn sm inline" @click="goPage('1', acnInfo)">{{ /*거래내역조회*/ $t("MMAIN-03-03-02-05") }}</button>
        <button class="btn sm inline" v-if="acnInfo.isTrsaccBtn && acnInfo.acnStus != '1'" @click="onTrsacc(acnInfo)">{{ /*이체하기*/ $t("MMAIN-03-03-01-02") }}</button>
      </div>
      <div class="btn-area--full" v-else-if="acnInfo.acnoKnd2 == '4'">
        <button class="btn sm inline" @click="goPage('1', acnInfo)">{{ /*거래내역조회*/ $t("MMAIN-03-03-02-05") }}</button>
        <button v-if="acnInfo.expirYmd > today" class="btn sm inline" @click="goPage('4', acnInfo)">{{ /*해지예상조회*/ $t("MMAIN-03-03-02-06") }}</button>
        <button v-else-if="acnInfo.expirYmd <= today && siteCode != $config.SITECODE_OGMMR" class="btn sm inline" @click="goTermi()">{{ /*예금해지*/ $t("MCOM-0000066") }}</button>
      </div>
      <div class="btn-area--full" v-if="acnInfo.acnoKnd2 == '2'">
        <button class="btn sm inline" @click="goPage('5', acnInfo)">{{ /*대출금상환*/ $t("MMAIN-03-03-02-17") }}</button>
        <button class="btn sm inline" @click="goPage('6', acnInfo)">{{ /*이자납부*/ $t("MMAIN-03-03-03-06") }}</button>
      </div>
      <i class="icon icon-dropdown" @click="toggleShow()" />
    </div>
    <!-- My account -->
    <div class="my-account" v-if="_.isNil(this.RBF0404L40.totalLineCnt2) && isInitData">
      <div class="cont-tit">
        <h6>My account</h6>
        <div v-if="siteCode == $config.SITECODE_OGMMR && isPersonalUser" class="mmqr-pay" @click="qrPayScan()">
          <i class="icon icon-mmqr" />
          <span>QR Pay</span>
        </div>
      </div>
      <div class="box-white -type4 regist">
        <div class="tit">{{ /*Favorite account를 등록해주세요.*/ $t("MMAIN-03-04-01-01") }}</div>
        <div class="dec">
          {{ /*메인 페이지에서 바로 확인할 수 있는 내 계좌를 등록해 보세요.*/ $t("MMAIN-03-04-01-02") }}
          <br />
          {{ /*계좌 조회를 들어가지 않아도 빠른 조회가 가능합니다.*/ $t("MMAIN-03-04-01-03") }}
        </div>
        <button class="btn plus" @click="onFvrtSet"></button>
      </div>
      <div class="box-white -type4" v-for="(item, i) in wdrwList.dataGrid2" :key="i">
        <div class="header" @click="toggleShow('1', i)">
          <div class="title">
            {{ item.acnoAls ? item.acnoAls : item.prdctName }}
            <div class="badge" :class="getColrCdCtnt(item)">
              {{ item.acnoKnd == "1" ? (item.acnoKnd2 == "3" ? /*입출금*/ $t("MMAIN-03-02-01-02") : /*예/적금*/ $t("MMAIN-03-02-01-03")) : /*대출*/ $t("MMAIN-03-02-01-04") }}
            </div>
          </div>
          <div class="desc">
            <div class="item account">
              {{ item.acnoKnd == "1" ? `${item.acno} - ${item.prdctName}` : `${item.acno} - ${/*대출금리*/ $t("MMAIN-03-03-02-16")} ${item.lnIrt ? item.lnIrt : "0"}%` }}
            </div>
          </div>
        </div>
        <div v-if="!showAcnDtl" class="content" @click="toggleShow('1', i)">
          <div class="account-info -type3">
            <div class="item amount">
              <span class="exchange-unit">{{ item.cncycd }}</span>
              <span class="total" v-html="item.acnoKnd == '1' ? $num(item.bal, null, true) : $num(item.lnBal, null, true)"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Favorite account -->
    <div class="favorite" v-if="!_.isNil(this.RBF0404L40.totalLineCnt2) && isInitData">
      <div class="cont-tit">
        <h6>Favorite account</h6>
        <div v-if="siteCode == $config.SITECODE_OGMMR && isPersonalUser" class="mmqr-pay" @click="qrPayScan()">
          <i class="icon icon-mmqr" />
          <span>QR Pay</span>
        </div>
        <div class="setting" @click="onFvrtSet">
          <i class="icon icon-setting" />
        </div>
      </div>
      <div class="box-white -type4" v-for="(item, i) in RBF0404L40.dataGrid2" :key="i">
        <div class="header" @click="toggleShow('2', i)">
          <div class="title">
            <div v-if="siteCode == $config.SITECODE_OGHCM && item.rpsntDrwotAcnYn == '1'" class="name text-ellipsis">
              <i class="icon icon-withdrawal-main" />{{ item.acnoAls ? item.acnoAls : item.prdctName }}
            </div>
            <div v-else>{{ item.acnoAls ? item.acnoAls : item.prdctName }}</div>
            <div class="badge" :class="getColrCdCtnt(item)">
              {{ item.acnoKnd == "1" ? (item.acnoKnd2 == "3" ? /*입출금*/ $t("MMAIN-03-02-01-02") : /*예/적금*/ $t("MMAIN-03-02-01-03")) : /*대출*/ $t("MMAIN-03-02-01-04") }}
            </div>
          </div>
          <div class="desc">
            <div class="item account">
              {{ item.acnoKnd == "1" ? `${item.acno} - ${item.prdctName}` : `${item.acno} - ${/*대출금리*/ $t("MMAIN-03-03-02-16")} ${item.lnIrt ? item.lnIrt : "0"}%` }}
            </div>
          </div>
        </div>
        <div v-if="!showAcnDtl" class="content" @click="toggleShow('2', i)">
          <div class="account-info -type3">
            <!-- 금액 표시 -->
            <div class="item amount" v-if="item.amtRepsntYn == '1'">
              <span class="exchange-unit">{{ item.cncycd }}</span>
              <span class="total" v-html="$num(item.bal, null, true)"></span>
            </div>
            <!-- 이자납입금액 표시 -->
            <div class="item amount" v-if="item.intPamtRepsntYn == '1'">
              <span class="date" v-if="item.acnStus == '2'">{{ `${$getGlobalDateFmt(item.nxtrmPaymtYmd)} (${$t("2_계좌상태구분코드")})` }}</span>
              <span class="date" v-else-if="item.rmainNxtrmPaymtNoday > 0 || item.rmainNxtrmPaymtNoday < 0"
                >{{ $getGlobalDateFmt(item.nxtrmPaymtYmd) }}
                {{ item.rmainNxtrmPaymtNoday > 0 ? `(D-${item.rmainNxtrmPaymtNoday.toString()})` : `(D+${(item.rmainNxtrmPaymtNoday * -1).toString()})` }}</span
              >
              <span class="date" v-else>{{ `${$getGlobalDateFmt(item.nxtrmPaymtYmd)}` }}</span>
              <!-- 당좌대출 차기이자납부금액 미표시 -->
              <span v-if="item.ovsesLnFmatDstcd != '08'" class="exchange-unit">{{ item.cncycd }}</span>
              <span v-if="item.ovsesLnFmatDstcd != '08'" class="total" v-html="$num(item.nxtrmIntPaymtAmt, null, true)"></span>
            </div>
            <!-- 당일 입/출금 합계 표시 -->
            <div class="item amount" v-if="item.ttddRcdrwSumRepsntYn == '1'">
              <span class="in">(in)</span>
              <span class="exchange-unit">{{ item.cncycd }}</span>
              <span class="total" v-html="$num(item.ttddMrvamtSum, null, true)"></span>
            </div>
            <div class="item amount" v-if="item.ttddRcdrwSumRepsntYn == '1'">
              <span class="out">(out)</span>
              <span class="exchange-unit">{{ item.cncycd }}</span>
              <span class="total" v-html="$num(item.ttddDrwotamtSum, null, true)"></span>
            </div>
            <div
              class="item sub"
              v-if="
                item.drwotAblamtRepsntYn == '1' ||
                  item.newYmdRepsntYn == '1' ||
                  item.dpostIrtRepsntYn == '1' ||
                  item.ctrcTrmRepsntYn == '1' ||
                  (item.updatYmdRepsntYn == '1' && item.expirExtenYn == '1') ||
                  item.lnAmtRepsntYn == '1' ||
                  item.lnBalRepsntYn == '1' ||
                  item.expirYmdRepsntYn == '1' ||
                  item.acnStusRepsntYn == '1'
              "
            >
              <div class="cont" v-if="item.drwotAblamtRepsntYn == '1'">
                <span class="tit">{{ /*출금 가능 금액*/ $t("MPAY-03-01-06-02") }}</span>
                <span class="dec">{{ $num(item.drwotAbilAmt) }}</span>
              </div>
              <div class="cont" v-if="item.newYmdRepsntYn == '1'">
                <span class="tit">{{ /*신규일*/ $t("MMAIN-03-04-10-05") }}</span>
                <span class="dec">{{ $getGlobalDateFmt(item.newYmd) }}</span>
              </div>
              <div class="cont" v-if="item.dpostIrtRepsntYn == '1'">
                <span class="tit">{{ /*예금 이율*/ $t("MMAIN-03-03-02-02") }}</span>
                <span class="dec">{{ `${item.dpostIrt}%` }}</span>
              </div>
              <div class="cont" v-if="item.ctrcTrmRepsntYn == '1'">
                <span class="tit">{{ /*계약기간*/ $t("MDEP-01-01-02-05") }}</span>
                <span class="dec">{{ `${$getGlobalDateFmt(item.expirYmd)} ~ ${$getGlobalDateFmt(item.newYmd)}` }}</span>
              </div>
              <div class="cont" v-if="item.updatYmdRepsntYn == '1' && item.expirExtenYn == '1'">
                <span class="tit">{{ /*갱신일*/ $t("MINQ-01-01-08-20") }}</span>
                <span class="dec">{{ $getGlobalDateFmt(item.expirExtenYmd) }}</span>
              </div>
              <div class="cont" v-if="item.lnAmtRepsntYn == '1'">
                <span class="tit">{{ /*대출금액*/ $t("MINQ-01-01-10-07") }}</span>
                <span class="dec">{{ $num(item.lnAmt) }}</span>
              </div>
              <div class="cont" v-if="item.lnBalRepsntYn == '1'">
                <span class="tit">{{ /*대출잔액*/ $t("MINQ-01-01-10-08") }}</span>
                <span class="dec">{{ $num(item.lnBal) }}</span>
              </div>
              <div class="cont" v-if="item.expirYmdRepsntYn == '1'">
                <span class="tit">{{ /*만기일*/ $t("MMAIN-03-03-02-03") }}</span>
                <span class="dec">{{ $getGlobalDateFmt(item.lnExpirYmd) }}</span>
              </div>
              <div class="cont" v-if="item.acnStusRepsntYn == '1'">
                <span class="tit">{{ /*계좌 상태*/ $t("MMAIN-03-03-03-04") }}</span>
                <span class="dec">{{ $t(`${item.acnStus}_계좌상태구분코드`) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="account-blank" v-if="this.RBF0404L40.totalLineCnt2 < $config.MAX_FVRT_ACN_CNT" @click="onFvrtSet">
        <span>Add Account</span>
      </div>
    </div>
    <div v-if="siteCode == $config.SITECODE_OGHCM" class="quick-menu">
      <div class="cont-tit">
        <h6>Quick Menu</h6>
      </div>
      <ul>
        <li
          class="wfull"
          v-if="this.isPersonalUser"
          @click="
            () => {
              $router.push({ name: 'depositList' });
            }
          "
        >
          <div class="quick-menu-item">
            <i class="icon icon-quick-new-acc" />
          </div>
          <span class="new">{{ /*계좌신규*/ $t("EKYC-01-01") }}<em>NEW</em></span>
        </li>
        <li
          @click="
            () => {
              $router.push({ name: 'phoneTopupReq' });
            }
          "
        >
          <div class="quick-menu-item">
            <i class="icon icon-quick-topup" />
          </div>
          <span>{{ /*휴대폰 요금충전*/ $t("MPAY-06-01-01-07") }}</span>
        </li>
        <li
          @click="
            () => {
              $router.push({ name: 'billPaymentMain' });
            }
          "
        >
          <div class="quick-menu-item">
            <i class="icon icon-quick-bill" />
          </div>
          <span>{{ /*공과금 납부*/ $t("MPAY-06-01-01-13") }}</span>
        </li>
      </ul>
    </div>
    <!-- DIV logo -->
    <div v-if="siteCode == $config.SITECODE_OGHCM" class="cont-img logo">
      <i class="icon img-DIV-logo"></i>
      <span class="v-hidden">Deposit insurance of Vietnam (DIV)</span>
    </div>
    <!--// DIV logo -->
    <!-- 이체 메뉴 이동 -->
    <modal-pop :opened.sync="openedTrsacc" :btn-close="true" class="modal">
      <template #content>
        <div>{{ /*이체 메뉴로 이동하시겠습니까?*/ $t("MINQ-01-01-06-16") }}</div>
      </template>
      <template #footer>
        <button class="btn bottom positive" @click="goPage('2')">{{ /*당행이체*/ $t("MINQ-01-01-06-17") }}</button>
        <button class="btn bottom positive" @click="goPage('3')">{{ /*타행이체*/ $t("MINQ-01-01-06-18") }}</button>
      </template>
    </modal-pop>
    <!-- 내계좌 -->
    <fvrt-acn-set-popup ref="fvrtAcnSetPopup" :opened.sync="openedFrvtSet" @change="changeFvrtSet" />
    <push-stup-popup ref="pushStupPopup" :opened.sync="isPushStupPopupOpen" />
    <personal-info-popup ref="personalInfoPopup" :opened.sync="isPersonalInfoPopupOpen" />

    <!-- motp 홍보 팝업 -->
    <action-sheet :opened.sync="motpAdPopupOpened" :action-header="false" :action-footer="false" class="main-action ad">
      <template #content>
        <!-- Korean -->
        <div v-if="lang == $config.LANG_KOR" class="ad-box kr">
          <div class="inn">
            <div class="tit">
              <i class="icon icon-main-pop-motp" />
            </div>
            <router-link tag="button" class="btn_go" :to="{ name: 'userGuideMotp' }">
              <em>mOTP</em> 발급하기
              <i class="icon icon-arrow-m-right-white" />
            </router-link>
          </div>
          <div class="inn_footer">
            <button class="btn" @click="notOpen()">하루동안 보이지 않기</button>
            <button class="btn close" @click="motpAdPopupOpened = !motpAdPopupOpened">닫기</button>
          </div>
        </div>
        <!-- English -->
        <div v-else-if="lang == $config.LANG_ENG" class="ad-box en">
          <div class="inn">
            <div class="tit">
              <span>More secured.</span>
              <span>More convenient.</span>
              <span class="with">with KB mOTP</span>
            </div>
            <router-link tag="button" class="btn_go" :to="{ name: 'userGuideMotp' }">
              ISSUE NOW
              <i class="icon icon-arrow-m-right-white" />
            </router-link>
          </div>
          <div class="inn_footer">
            <button class="btn" @click="notOpen()">Not seen for 1 day</button>
            <button class="btn close" @click="motpAdPopupOpened = !motpAdPopupOpened">Close</button>
          </div>
        </div>
        <!-- 현지어 -->
        <template v-else>
          <!-- Vietnamese -->
          <div v-if="siteCode == $config.SITECODE_OGHCM" class="ad-box vn">
            <div class="inn">
              <div class="tit">
                <span>An toàn hơn.</span>
                <span>Tiện lợi hơn.</span>
                <span class="with">cùng KB mOTP</span>
              </div>
              <router-link tag="button" class="btn_go" :to="{ name: 'userGuideMotp' }">
                ĐĂNG KÝ NGAY
                <i class="icon icon-arrow-m-right-white" />
              </router-link>
            </div>
            <div class="inn_footer">
              <button class="btn" @click="notOpen()">Không xem lại trong 1 ngày</button>
              <button class="btn close" @click="motpAdPopupOpened = !motpAdPopupOpened">Đóng</button>
            </div>
          </div>
          <!-- Khmer -->
          <div v-else-if="siteCode == $config.SITECODE_OGCBD" class="ad-box kh">
            <div class="inn">
              <div class="tit">
                <span>សុវត្ថិភាព។</span>
                <span>ងាយស្រួល។</span>
                <span class="with">ជាមួយ KB mOTP</span>
              </div>
              <router-link tag="button" class="btn_go" :to="{ name: 'userGuideMotp' }">
                ប្រើប្រាស់ឥឡូវនេះ
                <i class="icon icon-arrow-m-right-white" />
              </router-link>
            </div>
            <div class="inn_footer">
              <button class="btn" @click="notOpen()">មិនបង្ហាញសម្រាប់ 1ថ្ងៃ</button>
              <button class="btn close" @click="motpAdPopupOpened = !motpAdPopupOpened">បិទ</button>
            </div>
          </div>
        </template>
      </template>
    </action-sheet>
    <modal-pop :opened.sync="depoNewPopupOpened" :modalHeader="true" :modalFooter="true" :btnClose="true" :title="/*보통예금 신규*/ $t('EKYC-13-01')" class="modal">
      <template #content>
        <div>
          {{ $t("EKYC-13-02") /*계좌 개설을 위한 본인확인이 완료되었습니다.*/ }}<br />
          {{ $t("EKYC-13-03") /*이어서 거래해주시기 바랍니다. */ }}
        </div>
      </template>
      <template #footer>
        <button class="btn bottom positive" @click="depoNew">
          {{ $t("EKYC-13-04") /*계좌개설 이어가기*/ }}
        </button>
      </template>
    </modal-pop>
    <modal-pop :opened.sync="biometricNoticePopupOpen" :modalHeader="true" :modalFooter="true" :btnClose="true" :title="$t('EKYC-22-58')" class="modal error">
      <template #content>
        <div>
          <p v-html="$t('EKYC-22-48')"></p>
          <br />
          <p class="text-info align-left" v-html="$t('EKYC-22-49')"></p>
          <ul class="ulist bar text-black">
            <li class="highlight">{{ $t("EKYC-22-50") }}</li>
            <li class="highlight">{{ $t("EKYC-22-51") }}</li>
          </ul>
        </div>
      </template>
      <template #footer>
        <template>
          <button class="btn bottom positive" @click="biometricNoticePopupOpen = false">{{ $t("MOTP-03-01-04-10") /*확인*/ }}</button>
        </template>
      </template>
    </modal-pop>
    <modal-pop :opened.sync="idExpirationPopupOpen" :modalHeader="true" :modalFooter="true" :btnClose="true" :title="modalTitle" class="modal error">
      <template #content>
        <div>
          <p v-html="modalContents1"></p>
          <p v-if="modalContents2" v-html="modalContents2"></p>
          <p v-if="modalContents3" v-html="modalContents3"></p>
          <p class="mtop-20">{{ /*전화상담*/ $t("MCOM-0000031") }}</p>
          <div class="btn-area" v-if="operGroupCd == 'VN2'">
            <button class="btn lg inline" @click="$goToTel($t(`지점별콜번호_oghni`))">
              <i class="icon icon-call" />
              {{ $t(`지점별전화번호_oghni`) }}
            </button>
          </div>
          <div class="btn-area" v-else>
            <button class="btn lg inline" @click="$goToTel($t(`지점별콜번호_${siteCode}`))">
              <i class="icon icon-call" />
              {{ $t(`지점별전화번호_${siteCode}`) }}
            </button>
          </div>
        </div>
      </template>
      <template #footer>
        <template v-if="isPersonalUser && sessionInfo.userInfo.nativYn == '1'">
          <button class="btn bottom negative" @click="idExpirationPopupOpen = false">{{ $t("MOTP-03-01-03-04") /*닫기*/ }}</button>
          <button class="btn bottom positive" @click="$router.push({ name: 'createEkyc' })">{{ $t("FIDO-0031") /*등록하기*/ }}</button>
        </template>
        <template v-else>
          <button class="btn bottom positive" @click="idExpirationPopupOpen = false">{{ $t("MOTP-03-01-04-10") /*확인*/ }}</button>
        </template>
      </template>
    </modal-pop>
    <modal-pop :opened.sync="mmQRPopupOpended" :modalHeader="true" :modalFooter="true" class="modal">
      <template #content>
        <div class="align-center">
          <i class="icon img-mmqr-logo"></i>
          <span class="v-hidden">
            MyanmarPay
            <em>MMQR</em>
          </span>
        </div>
        <div class="align-center">
          <h5 style="line-height:inherit">{{ /*Welcome to Myanmar Pay*/ $t("MPAY-07-01-01-38") }}</h5>
          <div>{{ /*Now you can easily make the different digital payments with Myanmar Pay.*/ $t("MPAY-07-01-01-39") }}</div>
        </div>
      </template>
      <template #footer>
        <button
          class="btn bottom positive"
          @click="
            () => {
              (mmQRPopupOpended = false), (menuOpen = false), $router.push({ name: 'mmQRAgreeTermsConditions' });
            }
          "
        >
          {{ /*확인*/ $t("FIDO-0096") }}
        </button>
      </template>
    </modal-pop>
    <modal-pop :opened.sync="mmQRRejectPopupOpended" :modalHeader="true" class="error">
      <template #content>
        <div>
          <div class="error-code">
            <i class="icon icon-error" />
            <div>
              <strong>{{ /*Your account is currently inactive for this service.*/ $t("MPAY-07-01-01-40") }}</strong>
            </div>
          </div>
          <p>{{ /*Please contact KB Bank Myanmar for assistance.*/ $t("MPAY-07-01-01-41") }}</p>
          <p>{{ /*전화상담*/ $t("MCOM-0000031") }}</p>
          <div class="btn-area">
            <button class="btn lg inline" @click="$goToTel($t(`지점별콜번호_${siteCode}`))">
              <i class="icon icon-call" />
              {{ $t(`지점별전화번호_${siteCode}`) }}
            </button>
          </div>
        </div>
      </template>
       <template #footer>
        <button class="btn bottom positive" @click="mmQRRejectPopupOpended = !mmQRRejectPopupOpended">{{ /*확인*/ $t("MOTP-01-01-04-04") }}</button>
      </template>
    </modal-pop>
    <!-- <permission-popup ref="permission"></permission-popup> -->
    <update-popup ref="versionUpdate" />
    <modal-pop
      :opened.sync="pwPopupOpened"
      :modalHeader="true"
      :modalFooter="true"
      :btnClose="false"
      :title="/*새로운 비밀번호로 안전하게 관리해주세요!*/ $t('MMAIN-04-01-03-01')"
      class="modal"
    >
      <template #content>
        <div v-if="isUserPwdRegiYn == '4'">
          <p v-if="isCorporationSubUser">{{ $t("MACN-02-02-03-16") /*고객님의 안전한 사용을 위해 Sub-ID의 사용자암호를 1년마다 변경해야 합니다.*/ }}</p>
          <p v-else>{{ $t("MACN-02-02-03-15") /*고객님의 안전한 사용을 위해 베트남법에 의거 1년마다 사용자암호를 변경해야 합니다.*/ }}</p>
        </div>
        <div v-else>
          <p>{{ $t("MMAIN-04-01-03-02") /*고객님의 안전한 사용을 위해 6개월마다 사용자암호 변경을 권장하고 있습니다.*/ }}</p>
          <p class="caution mt10">※ {{ $t("MMAIN-04-01-03-03") /*다음에 변경을 선택하시면, 6개월 동안 이 페이지가 보이지 않습니다.*/ }}</p>
        </div>
      </template>
      <template #footer>
        <button v-if="isUserPwdRegiYn != '4'" class="btn bottom negative" @click="changeLater">{{ $t("MMAIN-04-01-03-05") /*다음에 변경*/ }}</button>
        <button v-if="!isCorporationSubUser" class="btn bottom positive" @click="changeNow">{{ $t("MMAIN-04-01-03-04") /*변경하기*/ }}</button>
        <button v-if="isCorporationSubUser" class="btn bottom positive" @click="close">{{ $t("FIDO-0028") /*앱 종료*/ }}</button>
      </template>
    </modal-pop>
  </article>
</template>

<script>
import FvrtAcnSetPopup from "@/components/page/main/FvrtAcnSetPopup";
import PushStupPopup from "@/components/page/common/PushStupPopup";
import PersonalInfoPopup from "@/components/layout/PersonalInfoPopup";
import { mapFields } from "vuex-map-fields";
import { RBF0401P40 } from "@/mixins/main";
import Common from "@/components/basic/Common";
import { mapGetters } from "vuex";
import NapasQR from "@/qr/NapasQR.js";
import CRCModule from "@/qr/CrcCitt.js";
//import PermissionPopup from "@/components/page/main/PermissionPopup";
import UpdatePopup from "@/components/layout/VersionUpdatePopup";

export default {
  extends: Common,
  props: ["showHeader", "isInit"],
  mixins: [RBF0401P40],
  components: {
    FvrtAcnSetPopup,
    PushStupPopup,
    PersonalInfoPopup,
    //PermissionPopup,
    UpdatePopup,
  },
  mounted() {
    this.today = this.$getDateToString();

    if (!this.isInitData) {
      this.getAddtlInfo(); //부가정보조회
      this.RBF0404L40Call(); //내계좌
      if (!this.isCustNtcInq) {
        this.RBF0401P40mainCall(); //PUSH발송내역조회
      }
    }

    // 비밀번호 사용 180일 초과시 또는 베트남 패스워드 정책 변경에 따른 새로운 비밀번호 설정 권유 팝업
    if ((this.isUserPwdRegiYn == "3" && !this.isCorporationSubUser) || this.isUserPwdRegiYn == "4") {
      this.pwPopupOpen();
    }

    if (this.siteCode == this.$config.SITECODE_OGHCM) {
      if (this.isPersonalUser) {
        // 베트남 && 개인 && 대상자
        if (this.sessionInfo.userInfo.marketingInfo == "Y") {
          // 마케팅 동의
          this.motpAdPopupOpen();
        }
        if (this.sessionInfo.userInfo.ppsnInfoGathrCnsntYn == "0") {
          // 개인정보수집 동의
          this.isPersonalInfoPopupOpen = true;
          return;
        }
        if (this.sessionInfo.userInfo.ppsnInfoGathrCnsntYn == "1" && this.isLvbdInfoRegiMandanCustYn && !this.isLvbdInfoRegiYn) {
          // 개인정보수집동의 1 && 생체정보등록필수고객여부 1 && 생체정보등록여부 0 -> 생체정보등록 화면
          this.$router.push({ name: "createEkyc" });
        }
        if (this.sessionInfo.userInfo.uniqnoValdDdStusDstcd != "0") {
          //신분증 만료일 없음 or 만료60일이내 or 만료
          //고유번호유효일상태구분코드(uniqnoValdDdStusDstcd, 0:정상,1:60일미만,8:만료일정보없음,9:만료일초과)
          this.modalTitle = this.$t("EKYC-22-38"); //신분증 정보 만료 알림
          if (this.sessionInfo.userInfo.nativYn == "1") {
            //내국인
            this.modalContents2 = this.$t("EKYC-22-34"); //중앙은행의 Circular 17/2024/TT-NHNN에  따라 신분증 유효기간 만료 시 출금 및 이체 거래가 일시적으로 중단됩니다.
            this.modalContents3 = this.$t("EKYC-22-35"); //신분증 정보 업데이트를 위해 IC칩 신분증을 사용하여 생체정보등록을 진행해주시기 바랍니다.
            if (this.sessionInfo.userInfo.uniqnoValdDdStusDstcd == "1") {
              //1:60일미만
              this.modalContents1 = this.$t("EKYC-22-33", { 1: this.$getGlobalDateFmt2(this.sessionInfo.userInfo.iDcdExpryDd) }); //고객님의 등록된 신분증 만료일자는 {1} 입니다.
            } else if (this.sessionInfo.userInfo.uniqnoValdDdStusDstcd == "9") {
              //9:만료일초과

              this.modalContents1 = this.$t("EKYC-22-39"); //고객님의 등록된 신분증 유효기간이 만료되었습니다.
              this.modalContents2 = this.$t("EKYC-22-40"); //중앙은행이 발표한 Circular 17/2024/TT-NHNN에 따라 출금 및 이체 거래가 일시적으로 중단되었습니다.
            }
          } else {
            //외국인
            this.modalContents2 = this.$t("EKYC-22-36"); //중앙은행이 발표한 Circular 17/2024/TT-NHNN에  따라 신분증 유효기간 만료 시 출금 및 이체 거래가 일시적으로 중단됩니다.
            this.modalContents3 = this.$t("EKYC-22-37"); //유효한 여권 및 VISA/거주증을 지참하여 영업점에 방문해주시기 바랍니다.
            if (this.sessionInfo.userInfo.uniqnoValdDdStusDstcd == "1") {
              //1:60일미만
              this.modalContents1 = this.$t("EKYC-22-33", { 1: this.$getGlobalDateFmt2(this.sessionInfo.userInfo.iDcdExpryDd) }); //고객님의 등록된 신분증 만료일자는 {1} 입니다.
            } else if (this.sessionInfo.userInfo.uniqnoValdDdStusDstcd == "9") {
              //9:만료일초과
              this.modalContents1 = this.$t("EKYC-22-39"); //고객님의 등록된 신분증 유효기간이 만료되었습니다.
              this.modalContents2 = this.$t("EKYC-22-40"); //중앙은행이 발표한 Circular 17/2024/TT-NHNN에 따라 출금 및 이체 거래가 일시적으로 중단되었습니다.
            }
          }
          this.idExpirationPopupOpen = true;
          //만료일 안내팝업
          return;
        }
        if (!this.isLvbdInfoRegiYn) {
          // 생체정보 미등록고객
          this.$router.push({ name: "createEkyc" });
        }
        if (this.sessionInfo.userInfo.connAcitmDstic == "11" && this.sessionInfo.userInfo.acnOpenPrgrsStusDstcd == "30") {
          this.depoNewPopupOpen();
        }
      } else {
        if (this.sessionInfo.userInfo.eceptPrcssDstcd == "00") {
          if (this.sessionInfo.userInfo.sbidDstcd == "1") {
            //마스터일때
            if (this.sessionInfo.userInfo.ppsnInfoGathrCnsntYn == "0") {
              // 개인정보수집 동의
              this.isPersonalInfoPopupOpen = true;
            }
            if (this.sessionInfo.userInfo.ppsnInfoGathrCnsntYn == "1" && !this.isLvbdInfoRegiYn) {
              // 생체정보등록필수고객여부 1 && 생체정보등록여부 0 -> 생체정보등록 화면
              if (this.ekycPageCallCnt == 0) {
                this.ekycPageCallCnt++;
                this.$router.push({ name: "createEkyc" });
              }
            }
          } else {
            //서브일때
            if (!this.isLvbdInfoRegiYn) {
              // 생체정보등록필수고객여부 1 && 생체정보등록여부 0 -> 안내팝업
              this.biometricNoticePopupOpen = true;
            }
          }
        }

        // 베트남 && 법인 && 대상자
        if (this.sessionInfo.userInfo.uniqnoValdDdStusDstcd != "0") {
          //신분증 만료일 없음 or 만료60일이내 or 만료
          //고유번호유효일상태구분코드(uniqnoValdDdStusDstcd, 0:정상,1:60일미만,8:만료일정보없음,9:만료일초과)
          this.modalTitle = this.$t("EKYC-22-41"); //기업고객에게 신분증 정보 만료 알림
          if (this.sessionInfo.userInfo.coprRlprNativYn == "1") {
            //내국인
            this.modalContents2 = this.$t("EKYC-22-43"); //중앙은행의 Circular 17/2024/TT-NHNN에 따라, 2025년 01월 01일부터, 신분증 유효기간 만료 시 출금 및 이체 거래가 일시적으로 중단됩니다.
            this.modalContents3 = this.$t("EKYC-22-44"); //신분증 정보 업데이트를 위해 <strong class='txt_caution'>IC칩 신분증을</strong> 지참하여 영업점에 방문해주시기 바랍니다.
            if (this.sessionInfo.userInfo.uniqnoValdDdStusDstcd == "1") {
              //1:60일미만
              this.modalContents1 = this.$t("EKYC-22-42", { 1: this.$getGlobalDateFmt2(this.sessionInfo.userInfo.iDcdExpryDd) }); //법인 대표자, 서명권자, 이해관계인의 등록된 신분증 만료일자는 <strong class='fc_point3'>{1}</strong> 입니다.
            } else if (this.sessionInfo.userInfo.uniqnoValdDdStusDstcd == "9") {
              //9:만료일초과
              this.modalContents1 = this.$t("EKYC-22-46"); //법인 대표자, 서명권자, 이해관계인의 등록된 신분증 유효기간이 만료되었습니다.
              this.modalContents2 = this.$t("EKYC-22-47"); //중앙은행의 Circular 17/2024/TT-NHNN에 따라 신분증 유효기간 만료 때문에 출금 및 이체 거래가 일시적으로 중단되었습니다.
            }
          } else {
            //외국인
            this.modalContents2 = this.$t("EKYC-22-43"); //중앙은행의 Circular 17/2024/TT-NHNN에 따라, 2025년 01월 01일부터, 신분증 유효기간 만료 시 출금 및 이체 거래가 일시적으로 중단됩니다.
            this.modalContents3 = this.$t("EKYC-22-45"); //<strong class='txt_caution'>유효한 여권 및 VISA/거주증</strong>을 지참하여 영업점에 방문해주시기 바랍니다.
            if (this.sessionInfo.userInfo.uniqnoValdDdStusDstcd == "1") {
              //1:60일미만
              this.modalContents1 = this.$t("EKYC-22-42", { 1: this.$getGlobalDateFmt2(this.sessionInfo.userInfo.iDcdExpryDd) }); //법인 대표자, 서명권자, 이해관계인의 등록된 신분증 만료일자는 <strong class='fc_point3'>{1}</strong> 입니다.
            } else if (this.sessionInfo.userInfo.uniqnoValdDdStusDstcd == "9") {
              //9:만료일초과
              this.modalContents1 = this.$t("EKYC-22-46"); //법인 대표자, 서명권자, 이해관계인의 등록된 신분증 유효기간이 만료되었습니다.
              this.modalContents2 = this.$t("EKYC-22-47"); //중앙은행의 Circular 17/2024/TT-NHNN에 따라 신분증 유효기간 만료 때문에 출금 및 이체 거래가 일시적으로 중단되었습니다.
            }
          }
          this.idExpirationPopupOpen = true;
          //만료일 안내팝업
          return;
        }
      }
    }

    // Push 설정안내 팝업
    if (this.sessionInfo.userInfo.sbidDstcd == "1" && _.isEmpty(this.sessionInfo.userInfo.pushRecvCnsntYn)) {
      this.isPushStupPopupOpen = true;
    } else {
      this.isPushStupPopupOpen = false;
    }

    if(this.$route.params.redirect == "/tran/mmQR/mmQrPaymentStep1"){
      this.qrPayScan();
    }
  },
  data() {
    return {
      today: "",
      acnIdx: -1, //선택한계좌idx
      acnIdxKnd: "0", //선택한계좌(1: my account, 2: favorite)
      acnInfo: {}, //선택한계좌

      wdrwList: [], //전계좌
      fvrtList: [], //내계좌

      emptyAcnList: [], //빈계좌

      showAcnDtl: false, //계좌상세보기
      openedFrvtSet: false, //내계좌설정
      openedTrsacc: false, // 이체 팝업표기 여부
      isPushStupPopupOpen: false,
      isPersonalInfoPopupOpen: false,
      biometricNoticePopupOpen: false,
      motpAdPopupOpened: false,
      pwPopupOpened: false,
      depoNewPopupOpened: false,
      idExpirationPopupOpen: false,
      modalTitle: "",
      modalContents1: "",
      modalContents2: "",
      modalContents3: "",

      fvrtAcn: null,
      qrStatus: "", // 금액 없을 때
      bankInfo: "",

      mmQRPopupOpended: false, //MMQR 첫 사용 고객을 위한 팝업
      mmQRRejectPopupOpended: false, //MMQR 서비스 사용 거절 팝업
      isJoin: false, //MMQR Test용
    };
  },
  computed: {
    ...mapFields(["siteCode", "sessionInfo", "lang", "addtlInfo", "mOtpPopup", "operGroupCd"]),
    ...mapFields("common/main", ["RBF0404L40", "isCustNtcInq", "ekycPageCallCnt", "makeQr"]),
    ...mapFields("deposit/termiUpdat", ["depositTermi", "RBF0404B40"]),
    ...mapFields("transfer", ["initDrwotAcno"]),
    ...mapGetters([
      "isPersonalUser",
      "isCorporationUser",
      "isUserOtpDstcd",
      "isLogin",
      "isCorporationSubUser",
      "isUserPwdRegiYn",
      "isLvbdInfoRegiMandanCustYn",
      "isLvbdInfoRegiYn",
    ]),
    ...mapGetters("native", ["getNativeAll"]),
    isInitData: {
      get() {
        return this.isInit;
      },
      set(value) {
        this.$emit("update:isInit", value);
      },
    },
  },
  methods: {
    async motpAdPopupOpen() {
      if (process.env.VUE_APP_API_CALL != "local") {
        if (this.mOtpPopup == "") {
          await this.$store.dispatch("native/actGetNativeData", "mOtpPopup");
        }

        if (Array.isArray(this.mOtpPopup) && this.mOtpPopup.length > 0) {
          let idx = this.mOtpPopup.findIndex(item => {
            return item.siteCode == this.siteCode;
          });
          if (idx > -1 && this.mOtpPopup[idx].dueDate >= this.moment().format("YYYYMMDD")) {
            return;
          } else {
            this.motpAdPopupOpened = true;
          }
        } else {
          this.motpAdPopupOpened = true;
        }
      }
    },
    // 암호 사용 180일 초과시 암호 변경 권유 팝업
    async pwPopupOpen() {
      this.pwPopupOpened = true;
    },
    // 베트남 계좌신규 eKYC 관련 계좌개설 이어가기 팝업
    async depoNewPopupOpen() {
      this.depoNewPopupOpened = true;
    },
    changeNow() {
      this.pwPopupOpened = false;
      this.$router.push({ name: "changePasswordKnowStep1" });
    },
    close() {
      this.$bridge.exitApp();
    },
    depoNew() {
      this.depoNewPopupOpened = false;
      this.$router.push({ name: "mobileNewReq" });
    },
    RBF0509L50Call() {
      this.requestData = {
        inquryUserIdnfr: this.sessionInfo.userInfo.userIdnfr,
        inquryPrcCd: "3",
      };
      this.$post("/customer/cust/UserPwdUptRes01", this.requestData, this.RBF0509L50Suc, this.RBF0509L50Fail, this.RBF0509L50Final);
    },
    RBF0509L50Suc(res) {
      this.RBF0509L50 = { ...res.outItem };
      this.$set(this.sessionInfo.userInfo, "userPwdRegiYn", "0");
      this.pwPopupOpened = false;
    },
    changeLater() {
      this.RBF0509L50Call();
    },
    notOpen() {
      let dueDate = this.moment()
        .add(1, "d")
        .format("YYYYMMDD");
      let popupData = [];
      let data = _.find(this.mOtpPopup, { siteCode: this.siteCode });
      this.$log.info(data);

      if (data === undefined) {
        popupData.push({
          siteCode: this.siteCode,
          dueDate: dueDate,
        });
      } else {
        let idx = this.mOtpPopup.findIndex(item => {
          return item.siteCode == this.siteCode;
        });
        this.$log.info(idx);
        this.$set(this.mOtpPopup[idx], "dueDate", dueDate);
      }

      this.$bridge.setNativeData({ mOtpPopup: popupData });
      this.$log.info("mOtpPopup2>>>>>>>>>>>>>>>>>>>>>>", this.mOtpPopup);
      this.motpAdPopupOpened = false;
    },
    //내계좌조회
    RBF0404L40Call() {
      this.loading = true;

      this.$post(
        "/account/fvrt/FvrtAcnInq",
        {},
        this.RBF0404L40Suc,
        null,
        () => {
          this.loading = false;
          this.isInitData = true;
        },
        null,
        false,
      );
    },
    RBF0404L40Suc(res) {
      let fvrtCnt = 0;

      if (res.outItem.myAcnYn == "0") {
        //출금계좌
        fvrtCnt = 0;

        this.wdrwList = res.outItem;
        this.RBF0404L40 = [];
        this.$log.info({ wdrwList: this.wdrwList });
      } else {
        //내계좌
        this.wdrwList = [];
        this.RBF0404L40 = res.outItem;

        if (this.RBF0404L40.totalLineCnt2) {
          fvrtCnt = this.RBF0404L40.totalLineCnt2;
        }

        if (this.siteCode == this.$config.SITECODE_OGHCM && this.makeQr && this.RBF0404L40.dataGrid2 != undefined) {
          // 베트남 QR 위젯 생성
          if (
            // 앱 최신버전(AOS-2.4.4, iOS-2.1.9)일 때만 QR 생성 브릿지 코드 호출
            (this.getNativeAll.smphMchtlDstcd == this.$config.OS_ANDROID && parseInt(this.getNativeAll.appVersionName.replace(/\./g, "")) >= 244) ||
            (this.getNativeAll.smphMchtlDstcd == this.$config.OS_IOS && parseInt(this.getNativeAll.appVersionName.replace(/\./g, "")) >= 219)
          ) {
            this.RBF0404L40.dataGrid2.forEach((item, index) => {
              if (item.rpsntDrwotAcnYn == "1") {
                // 베트남 메인출금계좌 불러오기
                this.fvrtAcn = this.RBF0404L40.dataGrid2[index];
              }
            });

            if (this.fvrtAcn != null) {
              // QR String 생성
              const napasInstance = new NapasQR();
              this.qrStatus = "11"; // 금액 없을 때
              if (this.operGroupCd == "VN1") {
                this.bankInfo = "970463";
              } else if (this.operGroupCd == "VN2") {
                this.bankInfo = "970462";
              }

              // 첫 번째 파라미터 "" : 수취인 없이 보내기
              let qrCrc = napasInstance.makeCRCWithQRString("", this.fvrtAcn.acno, "", this.fvrtAcn.cncycd, "VN", this.qrStatus, this.bankInfo);
              let newCrc = CRCModule.getCRC(qrCrc);
              let qrStr = napasInstance.convertKVtoQRString2("", this.fvrtAcn.acno, "", this.fvrtAcn.cncycd, "VN", newCrc, this.qrStatus, this.bankInfo);

              this.$bridge.setWidgetInfo("0", qrStr); // 브릿지 통신을 통해 네이티브로 값 전달
            } else {
              this.$bridge.setWidgetInfo("0", ""); // 브릿지 통신을 통해 네이티브로 공백값 전달
            }
            this.makeQr = false;
          }
        }

        this.$log.info({ RBF0404L40: this.RBF0404L40 });
      }

      //내계좌(empty)
      if (fvrtCnt < this.$config.MAX_FVRT_ACN_CNT) {
        this.emptyAcnList = new Array(this.$config.MAX_FVRT_ACN_CNT - fvrtCnt).fill(fvrtCnt).map((n, i) => {
          return n + i;
        });
      }

      this.toggleShow();
    },
    //입출금거래내역 조회
    async RBF0404A40Call() {
      let params = {
        acno: this.acnInfo.acno, //계좌번호
        tranStartYmd: this.moment()
          .subtract(12, "M")
          .format("YYYYMMDD"), //거래일자1
        tranEndYmd: this.moment().format("YYYYMMDD"), //거래일자2
        brncoInotDstcd: "00", //입출금구분 00:전체
        resultSeq: "01", //결과순서
        dmndPageNo: 1,
        pageLineCnt: 3,
        chnlDstcd: "01",
      };
      this.$post("/account/trnhis/OndmdTrnhis", params, this.RBF0404A40Suc);
    },
    RBF0404A40Suc(res) {
      if (!_.isNil(res.outItem.dpstAcnGrid) && res.outItem.dpstAcnGrid.length > 0) {
        this.acnInfo.dpstAcnGrid = res.outItem.dpstAcnGrid;
        this.$forceUpdate();
      }
    },
    //부가정보조회
    getAddtlInfo() {
      let params = { userIdnfr: this.sessionInfo.userInfo.userIdnfr, typeInfo: "permittedTrx" };

      this.$post("/commonbiz/combiz/getAddtlInfo", params, this.RBF0400F40Suc);
    },
    RBF0400F40Suc(res) {
      this.addtlInfo = res.outItem;
    },
    async onFvrtSet() {
      await this.$refs.fvrtAcnSetPopup.init();
      this.openedFrvtSet = true;
    },
    toggleShow(knd, num) {
      if (num > -1) {
        if (this.acnIdxKnd != knd || this.acnIdx != num) {
          this.acnIdx = num;
          this.acnIdxKnd = knd;

          if (knd == "1") {
            this.acnInfo = this.wdrwList.dataGrid2[this.acnIdx];
          } else if (knd == "2") {
            this.acnInfo = this.RBF0404L40.dataGrid2[this.acnIdx];
          }

          if (!this.showAcnDtl) {
            this.showAcnDtl = true;
            this.$emit("update:showHeader", false);
          }

          if (this.acnInfo.acnoKnd2 == "3") {
            //입출금 거래내역 조회
            this.RBF0404A40Call();
          }
        } else {
          if (this.showAcnDtl) {
            this.acnIdx = -1;
            this.acnIdxKnd = "0";
          }

          this.showAcnDtl = !this.showAcnDtl;
          this.$emit("update:showHeader", !this.showAcnDtl);
        }
      } else {
        this.acnIdx = -1;
        this.acnIdxKnd = "0";
        this.showAcnDtl = false;
        this.$emit("update:showHeader", true);
      }
    },
    isShow(num) {
      if (this.acnIdx == num) return true;
      return false;
    },
    getColrCdCtnt(data) {
      var regExp = /[type][0-9]/gi;

      if (regExp.test(data.colrCdCtnt)) {
        return "-" + data.colrCdCtnt;
      } else {
        return data.acnoKnd == "1" ? (data.acnoKnd2 == "3" ? "-type1" : "-type2") : "-type3";
      }
    },
    changeFvrtSet() {
      this.isInitData = false;
      this.RBF0404L40Call();
      // this.$forceUpdate();
    },
    onTrsacc(data) {
      this.initDrwotAcno.acno = data.acno;
      this.initDrwotAcno.cncycd = data.cncycd;
      this.initDrwotAcno.alias = data.acnoAls;

      if (this.siteCode == this.$config.SITECODE_OGCBD) {
        this.goPage("2");
      } else {
        this.openedTrsacc = true;
      }
    },
    //해지
    async goTermi() {
      if (this.acnInfo.acnStus == "1") {
        this.errMsg = this.$t(
          /*사고신고 상태에서는 해지를 하실 수 없습니다.<br/><br/>가까운 영업점을 방문하시어 사고신고 해제를 먼저하시고 계좌 해지를 진행해 주시기 바랍니다.*/ "MDEP-02-01-08-17",
        );
        this.openedError = true;
        return false;
      }

      let param = {
        termiYmd: this.moment().format("YYYYMMDD"),
        trsaccKnd: "1", //1:해지예상조회,0:예비거래
        acno: this.acnInfo.acno, //계좌번호
        cncycd: this.acnInfo.cncycd, //통화코드
      };
      this.$set(this.depositTermi, "acnoAls", this.acnInfo.acnoAls);
      this.RBF0404B40 = this.acnInfo;

      /* API_RBF0406D40 - 예금해지예상조회 호출 */
      await this.$post("/deposit/updat/TermiAnticiInq", param, this.termiSucc);
    },
    termiSucc(res) {
      this.$set(this.depositTermi, "expectation", res.outItem);
      this.$router.push({ name: "termiStep1" });
    },
    goPage(knd, data) {
      let pageName;
      let params;

      if (knd == "1") {
        //거래내역조회
        if (data.acnoKnd2 == "3") {
          pageName = "transactionDetails";
          params = {
            acno: data.acno,
            rangeIndex: this.$config.CALENDAR_RANGE_12M,
          };
        } else {
          //1,2,3:예금 4:적금 5:대출
          if (data.acnDtailCd == "4") {
            //적금 거래내역조회
            this.$router.push({ name: "instypFxdepTrnhis" });
          } else if (data.acnDtailCd == "5") {
            //대출 거래내역조회
            this.$router.push({ name: "lnAcnTrnhis" });
          } else {
            //예금 거래내역조회
            this.$router.push({ name: "dfstlFxdepTrnhis" });
          }
        }
      } else if (knd == "2") {
        //이체하기 (당행)
        pageName = "trsaccInfoInptStep1";
      } else if (knd == "3") {
        //이체하기 (타행)
        if (this.siteCode == this.$config.SITECODE_OGHCM && this.isLogin && (this.isUserOtpDstcd == "02" || this.isUserOtpDstcd == "03")) {
          pageName = "vtnOtrbnkTrsaccInfoInptReqStep1";
        } else if (this.siteCode == this.$config.SITECODE_OGMMR && this.isLogin) {
          pageName = "cbmnetTrsaccInfoInptReqStep1";
        } else {
          pageName = "otrbnkTrsaccInfoInptReqStep1";
        }
      } else if (knd == "4") {
        //해지예상조회
        pageName = "termiUpdatList";
      } else if (knd == "5") {
        //대출금상환
        pageName = "lnamtRpayAnticiInqStep1";
        params = data;
      } else if (knd == "6") {
        //이자납부
        pageName = "interestLoanPaymentStep1";
        params = data;
      }

      if (!_.isEmpty(pageName)) {
        if (_.isEmpty(params)) {
          this.$router.push({ name: pageName });
        } else {
          this.$router.push({ name: pageName, params: params });
        }
      }
    },
    //MMQR Pay
    qrPayScan() {
      //QR스캔하기 전에 버전 확인 후, 하위 버전일 경우 업데이트 팝업 표출
      if (this.$refs.versionUpdate.checkVersion()) return;

      this.$post("/transfer/mntacc/MMQRPrgrsStusDstcd", {}, this.RBF040A440Suc);
    },
    RBF040A440Suc(res) {
      let prgrsStusDstcd = res.outItem.prgrsStusDstcd;
      //prgrsStusDstcd(진행상태구분코드) 00:미가입, 01:가입, 91:가입실패, 99:서비스사용거절

      if (prgrsStusDstcd == "00" || prgrsStusDstcd == "91") {
        //onboading 미가입
        //MMQR 팝업 , MMQR 서비스 약관동의 화면으로 이동
        this.mmQRPopupOpended = true;
      } else if (prgrsStusDstcd == "01") {
        //onboading 가입
        //QR스캔으로 가기 위한 권한 체크
        let permissions = ["1", "2"]; // 1 = camera, 2 = photo
        this.$bridge.checkPermissions(permissions);
      }
      /* else if (prgrsStusDstcd == "90") {
        //onboading 가입 진행 중
        //failed 화면으로 이동
        this.$router.push({ name: "mmQRServiceJoinProcessing" });
      } else if (prgrsStusDstcd == "91") {
        //onboading 가입 실패
        //failed 화면으로 이동
        this.$router.push({ name: "mmQRServiceJoinFailed" });
      } */
      else if (prgrsStusDstcd == "99") {
        //onboading 가입거절
        //서비스사용 거절 팝업
        this.mmQRRejectPopupOpended = true;
      }
    },
  },
};
</script>